import React, { useContext } from "react";
import "./privacy.css";
import { MyContext } from "../../Context/MyContext";
import AppIcon from "../../Components/AppIcon";

const PrivacyPolicy = () => {
  const { privacy } = useContext(MyContext);
  const { title, description, sections } = privacy || {};
  const safeSections = Array.isArray(sections) ? sections : [];

  return (
    <section className="privacy-container">
      <br /><br />
      <div className="privacy-wrapper">
        <div className="privacy-content">
          <h2>{title}</h2>
          <p>{description}</p>
          <div className="privacy-sections">
            {safeSections.map((item) => (
              <div key={item.id} className="privacy-card">
                {item.icon ? <span className="icon"><AppIcon name={item.icon} size={24} /></span> : null}
                <h3>{item.title}</h3>
                <p>{item.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;